import { ReactNode } from "react";

export interface TeamProfileProps {
    teamName: string;
    teamDescription: ReactNode;
    teamImagePath: string;
    officer1?: ReactNode;
    officer2?: ReactNode;
}

const TeamProfile = ({ teamName, teamDescription, teamImagePath, officer1, officer2 }: TeamProfileProps) => {
    return (
        <div
            style={{
                width: "100%",
                maxWidth: "920px",
                margin: "20px auto",
                padding: "20px",
                //boxSizing: "border-box",
                borderRadius: "8px",
                backgroundColor: "#050A44",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            }}
        >
            {/* Team Information */}
            <div style={{ marginBottom: "20px" }}>
                <h1 style={{ fontSize: "28px", fontWeight: "bold", marginBottom: "10px" }}>
                    {teamName}
                </h1>
                <img src={teamImagePath}
                    alt="team"
                    style={{
                        width: "650px",
                        objectFit: "cover",
                        borderRadius: "8px"
                    }} />
                <p style={{ fontSize: "16px", lineHeight: "1.5" }}>
                    {teamDescription}
                </p>
            </div>
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    //gap: "16px",
                    alignItems: "flex-start",
                    width: "100%",
                    //boxSizing: "border-box",
                }}
            >
                {officer1}
                {officer2}
            </div>

        </div>
    );
};

export default TeamProfile;
